import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/lrbrain-theme.css';
import App from './App';
import GoogleAuthGate from './components/GoogleAuthGate';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <GoogleAuthGate>
        <App />
      </GoogleAuthGate>
    </BrowserRouter>
  </React.StrictMode>
);
